import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=2bf1f2bd&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"
import style0 from "./Videos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Videos.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Videos.vue?vue&type=style&index=2&id=2bf1f2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1f2bd",
  null
  
)

export default component.exports